/**
 * Warm cream page palette for marketing / public website routes.
 * Derived from base #DBD1C0 — taupe/cream tones, not neutral grey.
 */

/** Nav bar, footer shell, page background. */
export const WEBSITE_PAGE_BACKGROUND = '#DBD1C0';

/** Slightly darker warm cream — footer link columns, elevated inset sections. */
export const WEBSITE_PAGE_BACKGROUND_MUTED = '#CEC3B0';

/** Darker taupe — optional footer bottom strip, borders, subtle hierarchy. */
export const WEBSITE_PAGE_BACKGROUND_DARK = '#B8AD9A';

/**
 * Warm taupe scrollbars (website + staff light).
 * Mirrored as --website-scrollbar-* in styles/marketing-interior.css.
 */
export const WEBSITE_SCROLLBAR_TRACK = WEBSITE_PAGE_BACKGROUND;
export const WEBSITE_SCROLLBAR_THUMB = WEBSITE_PAGE_BACKGROUND_DARK;
export const WEBSITE_SCROLLBAR_THUMB_HOVER = '#A69B88';

/** Staff dark mode — warm charcoal surfaces (inverse of cream palette). */
export const STAFF_DARK_BACKGROUND = '#1c1916';
export const STAFF_DARK_SURFACE_MUTED = '#2e2a24';
export const STAFF_DARK_SURFACE_ELEVATED = '#3d3830';

/**
 * Staff light mode — parchment surfaces (inverse of STAFF_DARK_SURFACE_*).
 * Cream/taupe only, never #fff. Page default stays WEBSITE_PAGE_BACKGROUND;
 * muted/border reuse WEBSITE_PAGE_BACKGROUND_MUTED / _DARK.
 */
export const STAFF_LIGHT_SURFACE_ELEVATED = '#E8E0D2';
